import React, { ReactNode, MouseEvent } from "react";
import { IconButton, IconButtonProps } from "@mui/material";

interface SocialMediaIconProps {
  href?: string;
  children: ReactNode;
  color?: IconButtonProps["color"];
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

function SocialMediaIcon({ href, children, onClick }: SocialMediaIconProps) {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(event);
    }
    if (href) {
      window.open(href, "_blank");
    }
  };
  return <IconButton onClick={handleClick}>{children}</IconButton>;
}

export default SocialMediaIcon;
